module.exports = __webpack_public_path__ + "09e00aa7622ece30a0f1e06b55f66c2a.eot";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/OpenSans-Light-webfont.eot
// module id = 623
// module chunks = 0